import { createSelector } from "reselect";

const eventDataSelector = (state) => state.event;

const resultSelector = createSelector(eventDataSelector, (payload) => {
  return {
    loading: payload.get("loading"),
    allEvents: payload.get("allEvents"),
    allGrows: payload.get("allGrows"),
    allGrowsUsersSketch: payload.get('allGrowsUsersSketch'),
    metadata: payload.get("metadata"),
    allLiveEvents: payload.get("allLiveEvents"),
    liveEvent: payload.get("liveEvent"),
    updatedEvent: payload.get("updatedEvent"),
    error: payload.get("error"),
    myEvents: payload.get("myEvents"),
    channelEvents: payload.get("channelEvents"),
    allEventsChannels: payload.get("allEventsChannels"),
    boxesSaves: payload.get("boxesSaves"),
    allEventsUsersSketch: payload.get("allEventsUsersSketch"),
    allEventsAchivements: payload.get("allEventsAchivements"),
  };
});

export const eventSelector = (state) => ({
  ...resultSelector(state),
});
